<template>
    <div class="row">
        <div class="col-12 col-sm-6">
            <div class="form-group">
                <label for="title">Questionnaire Title</label>
                <input type="text" class="form-control" id="title" placeholder="Enter Title" v-model="categoryData.title">
            </div>

            <div class="form-group">
                <draggable v-model="categoryData.statements">
                    <transition-group name="list-transition">
                        <div
                            v-for="(statement, index) in categoryData.statements"
                            class="d-block py-2"
                            :key="null || index"
                        >
                            <div class="form-group d-flex">
                                <label class="mb-0 pr-3 d-flex align-items-center">Statement</label>
                                <input type="text" class="form-control" placeholder="Enter Title" v-model="statement.title">
                                <a class="ml-2" @click="deleteStatement(index)">
                                    <img :src="`/svg/${resourceGroup}/bin.svg`">
                                </a>
                            </div>
                        </div>
                    </transition-group>
                </draggable>

                <a href="javascript:void(0)" class="btn btn-primary" @click="addStatement()">+ Add Statement</a>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        name: "SiteSurveyInspectionCreateEditPage",

        components: {
            draggable
        },

        props: {
            method: {
                type: String,
                default: 'post'
            },
            submitUrl: {
                type: String,
                required: true
            },
            deleteUrl: {
                type: String,
                required: true
            },
            redirectUrl: {
                type: String,
                required: true
            },
            category: {
                type: Object,
                default: () => { return {} }
            }
        },

        data(){
            return {
                categoryData: {
                    title: '',
                    statements: []
                },

                saving: false,
                errors: []
            }
        },

        beforeMount() {
            this.categoryData = {...this.categoryData, ...this.category};

            window.addEventListener('LAYOUT:primary_button', this.save);
            window.addEventListener('LAYOUT:cancel_button', this.cancel);
        },

        methods: {
            save: function(){
                this.errors = [];

                if (this.saving){
					return false;
                }

				this.saving = true;

                axios({
                    'method': this.method,
                    'url': this.submitUrl,
                    'data': this.categoryData
                }).then((response) => {
                    this.saving = false;
                    window.location.href = this.redirectUrl;
                }).catch((error) => {
                    if(error.response.data.errors !== undefined){
                        Object.values(error.response.data.errors).forEach((err, i) => {
                            this.errors.push(`<li>${err[0]}</li>`);
                        });
                    }

                    if (this.errors.length >= 2) {
                        Vue.$toast.open({
                            message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    } else if (this.errors.length === 1) {
                        Vue.$toast.open({
                            message: `There was an error: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    }
                    this.saving = false;
                });
            },

            cancel: function (){
                window.location.href = this.redirectUrl;
            },

            addStatement: function(){
                this.categoryData.statements.push({
                    title: ''
                });
            },

            deleteStatement: function(index){
                let statement = this.categoryData.statements[index];

                if(statement.id === undefined){
                    Vue.delete(this.categoryData.statements, index);
                    Vue.$toast.open({
                        message: 'Statement Deleted',
                        type: 'success'
                    });
                } else {
                    axios.delete(this.deleteUrl.replace('?', statement.id))
                        .then(() => {
                            Vue.delete(this.categoryData.statements, index);
                            Vue.$toast.open({
                                message: 'Statement Deleted',
                                type: 'success'
                            });
                        })
                        .catch(() => {
                            Vue.$toast.open({
                                message: "Category Couldn't be deleted please try again",
                                type: 'error'
                            });
                        });
                }
            }
        },

        computed: {
            resourceGroup: () => {
                return window.resource_group;
            }
        }
    }
</script>
